import createPersistedState from "vuex-persistedstate";

// Import Vuex modules
import Alert from "./modules/alert";
import Auth from "./modules/auth";
import Bookings from "../domain/bookings/vuex/bookings";
import BookingCabins from "../domain/bookings/vuex/booking-cabins";
import Cruises from "../domain/cruises/vuex/cruises"
import CruiseCabins from "../domain/cruises/vuex/cruise-cabins";
import Logs from "../domain/logs/vuex/logs";
import ParkingOptions from "../domain/ancillaries/vuex/parking-options";
import Passengers from "../domain/bookings/vuex/passengers";
import Permissions from "../domain/permissions/vuex/permissions";
import Roles from "../domain/users/vuex/roles";
import RoleUsers from "../domain/permissions/vuex/role_users";
import Ships from "../domain/ships/vuex/ships";
import Sidebar from "./modules/sidebar";
import Users from "../domain/users/vuex/users";
import Enquiries from "../domain/Enquiries/vuex/enquiries";
import EnquiryNotes from "../domain/enquiry_notes/vuex/enquiry_notes";
import enquiryBrochures from "../domain/Enquiries/vuex/enquiry_brochures";
import enquiryBrochureEnquiries from "../domain/Enquiries/vuex/enquiry_brochure_enquiries"
import Customers from "../domain/mas/vuex/customers";
import MasSettings from "../domain/mas/vuex/settings";
import Ports from "../domain/ports/vuex/ports";
import Itineraries from "../domain/itinerary/vuex/itineraries";

export default {
    modules: {
        alert: Alert,
        auth: Auth,
        bookings: Bookings,
        bookingCabins: BookingCabins,
        cruises: Cruises,
        cruiseCabins: CruiseCabins,
        logs: Logs,
        parkingOptions: ParkingOptions,
        passengers: Passengers,
        permissions: Permissions,
        roles: Roles,
        role_users: RoleUsers,
        ships: Ships,
        sidebar: Sidebar,
        users: Users,
        enquiries: Enquiries,
        enquiry_notes: EnquiryNotes,
        enquiry_brochures: enquiryBrochures,
        enquiry_brochure_enquiries: enquiryBrochureEnquiries,
        customers: Customers,
        settings: MasSettings,
        ports: Ports,
        itineraries: Itineraries,
    },
    plugins: [
        createPersistedState({
            storage: window.localStorage,
            paths: [
                'auth',
                'storeVersion'
            ]
        })
    ],
    state() {
        return {
            storeVersion: 1,
        }
    },
    getters: {
        typeBindings (state) {
            return {
                'booking': 'bookings',
                'booked_cabin': 'bookingCabins',
                'cruise': 'cruises',
                'cruise-cabin': 'cruiseCabins',
                'parking-option': 'parkingOptions',
                'passenger': 'passengers',
                'ship': 'ships',
                'enquiries': 'enquiries',
                'enquirynote': 'enquiry_notes',
                'brochure': 'enquiry_brochures',
                'brochureenquiry': 'enquiry_brochure_enquiries',
                'user': 'users',
            };
        }
    }
}
